export default __webpack_public_path__ + "static/media/README.a83c2552.md";